<template>
  <div
    class="f-column"
    style="gap: 0.5rem"
  >
    <AnalyzeHandIcons
      class="mr-auto my-auto gw_box"
      style="
        margin: 0 3rem 0 0;
        height: 1.75rem;
        padding: 0 0.5rem;
        --clr-box-back: var(--clr-black-1-3);
      "
      tableMutation="api_poker_practice_hands"
      :handDetailItem="handDetailItem"
      apiVersion="v1"
      idKey="id"
      drawerItemId="trainer_hand_history_item"
      detailMutation="api_poker_practice_hand_detail"
      :getDetailEndpoint="item => `poker/practice/practice-hands/${item.id}/`"
    />
    <portal to="custom_drawer_after">
      <TrainerReplay
        v-if="analyzeItem"
        class="trahhitem_replay"
        :namespace="replayNamespace"
        :open="panelReplay"
        :historyHand="analyzeItem.historyHand"
        :setNamespace="false"
        :sessionInProgress="!handsConfigure"
        :restoreHandOnly="true"
        :hasSilentFetch="false"
        :hasControlIcons="mobile"
        :loading="mobile && loading"
        :controlsIconsProps="{
          publicId: analyzeItem ? analyzeItem.id : '',
          lastSpotLink: lastSpotLink,
          dataTableId: 'PracticeHandsTable',
          apiMutation: 'api_poker_practice_hands',
        }"
      />
    </portal>

    <div
      v-if="loading || loadingGmf"
      class="mt-14 d-flex w-100"
    >
      <v-progress-circular
        :size="88"
        class="ma-auto"
        data-tst="trainer_hand_history_item_loader"
        :model-value="80"
        :indeterminate="true"
      ></v-progress-circular>
    </div>

    <GwMessage
      v-if="!loading && warningZeroLine"
      :message="{
        icon: 'mdi-alert-circle-outline',
        type: 'warning',
      }"
      style="--font-icon: 1.25rem; --gap: 0.5rem; --back-padding: 0.75rem 1rem"
      class="w-100"
    >
      <div class="f-column text-medium">
        <div v-html="$t(`messages.zero_frequency_line`)"></div>
        <a
          class="clr-white text-underline"
          target="_blank"
          href="https://blog.gtowizard.com/understanding-nash-distance/"
          >{{ $t('common.read_more') }}</a
        >
      </div>
    </GwMessage>

    <ExpandCard
      v-if="!loading && !loadingGmf && analyzeItem"
      style="
        --max-height: 9999rem;
        --min-height: 3.25rem;
        --clr-back-content: var(--clr-black-1-3);
        --content-padding: 0 0.5rem;
        --radius-open: 4px;
        --radius-closed: 4px;
        --transition: 0s;
        --transition-content: 0s;
      "
      :hasScrollIntoView="false"
      :canClose="false"
      data-tst="trainer_hand_history_item"
      @click.stop
    >
      <template #title>
        <HaTitle
          :correctness_group="analyzeItem.historyHand.correctness.correctness_group"
          :hand="analyzeItem.hand_hero"
          :boards="analyzeItem.boards"
        />
      </template>
      <div
        class="position-relative ha-street-blocks"
        style="--ha-aa-width: 8rem"
      >
        <div class="ha-street-block">
          <HaControls
            :lastSpotLink="lastSpotLink"
            @click:replay="openReplayer"
            @click:capture="capt_capture()"
          />
        </div>
        <div
          id="capture"
          class="f-column"
          style="background: var(--clr-back-content); gap: var(--ha-gap)"
        >
          <HandDetailLogo
            v-if="capt_inProgress"
            style="position: absolute; top: 3.25rem; right: 1rem"
          />

          <div
            class="f-column"
            style="gap: var(--ha-gap)"
          >
            <div class="ha-street-block">
              <HaGameformat
                :item="haGmfItem"
                :dateConf="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                  hour: true,
                  minute: true,
                  second: false,
                }"
              />
              <HaPlayers
                :players="analyzeItem.players"
                :hero="analyzeItem.hero.position"
                :opponent="analyzeItem.opponent.position"
              />
            </div>
          </div>
          <AnalyzeStreetBlocks
            :showBetsIn="showBetsIn"
            :showEvIn="showEvIn"
            :item="analyzeItem"
            :hasShowdown="false"
            :replayedSpotId="panelReplay ? replayedSpot.id : null"
            :hasOpenAll="!capt_inProgress"
          />
        </div>
      </div>
    </ExpandCard>
  </div>
</template>

<script>
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import AnalyzeHandIcons from '@/components/Analyze/AnalyzeHand/AnalyzeHandIcons'
import GwMessage from '@/components/Messages/GwMessage'
import { getGameformat, getGameformatGroup } from '@/store/gameformat/gameformat'
import {
  getCompleteHistorySpots,
  getHistorySpots,
  getGroupFoldHistorySpots,
  setHistoryEventType,
  getHistorySpotsUrlParams,
  getLastSpotsOpponent,
  getHistoryUrlParams,
} from '@/store/gamestate/gamestate'
import { getHandCorrectness, getHandStats } from '@/helpers/trainer'
import { findDrill } from '@/helpers/trainer_presets'

import TrainerReplay from '@/components/Trainer/TrainerReplay'
import HaPlayers from '@/components/AnalyzeStreetBlocks/HaPlayers'
import HaGameformat from '@/components/AnalyzeStreetBlocks/HaGameformat'
import HaTitle from '@/components/AnalyzeStreetBlocks/HaTitle'
import HaControls from '@/components/AnalyzeStreetBlocks/HaControls'
import AnalyzeStreetBlocks from '@/components/AnalyzeStreetBlocks/AnalyzeStreetBlocks'

import capture_mix from '@/mixins/capture_mix'
import format_mix from '@/mixins/format_mix'
import links_mix from '@/mixins/links_mix'
import HandDetailLogo from '@/components/hhv3/Analyzer/HandDetail/HandDetailLogo.vue'

export default {
  name: 'TrainerHandHistoryItem',
  components: {
    HandDetailLogo,
    TrainerReplay,
    HaGameformat,
    AnalyzeStreetBlocks,
    HaPlayers,
    HaTitle,
    HaControls,
    ExpandCard,
    AnalyzeHandIcons,
    GwMessage,
  },
  mixins: [format_mix, capture_mix, links_mix],
  props: {},
  data() {
    this.replayNamespace = 'tra/replay' // tra/replay - 'trainer_restore_hand' expects tra/replay
    return {
      analyzeItem: null,
      isFavorite: false,
      loadingGmf: false,
    }
  },
  methods: {
    openReplayer() {
      this.$store.commit(`panels_set`, { key: 'panel_replay', value: !this.panelReplay })
    },
    async handleLoaded() {
      if (this.loaded) {
        this.analyzeItem = await this.getAnalyzeItem()
        this.isFavorite = this.apiData.marked
        this.setReplay()
      }
    },
    setReplay() {
      const { historyHand } = this.analyzeItem

      const namespace = this.replayNamespace
      this.$store.commit(`${namespace}/gamestate_set`, {
        key: 'history_spots',
        value: historyHand.history_spots,
      })

      const hp = getHistoryUrlParams({ history_spots: historyHand.history_spots })
      hp.history_spot = historyHand.history_spots.find(i => i.is_active)?.id || ''

      this.$store.dispatch(`${namespace}/router_update_query`, {
        query: {
          ...hp,
          ...historyHand.query,
          fh_trainer_game_mode: 'trainer_actions', // FORCE this mode as BE dont store inputed frequencies
        },
        push: false,
        replace: false,
        saveLocally: false,
      })

      this.$store.commit('drills_set', {
        key: 'drills_selected_drill',
        value: historyHand.selected_drill,
      })
      this.$store.commit(`${namespace}/trainer_reset`, historyHand.trainerState)

      this.$store.commit(`${namespace}/trainer_set`, {
        key: 'trainer_quick_result_visible',
        value: false,
      })
      this.$store.commit(`${namespace}/trainer_set`, { key: 'trainer_result_visible', value: true })
      this.$store.commit(`${namespace}/trainer_set`, { key: 'trainer_hand_finished', value: true })
    },
    getGameLink({ pathName = 'StudySolutions', spot }) {
      const customQuery = {
        ...spot?.urlParams,
        ...this.gmfQuery,
        soltab: this.$store.getters.sw_tabs_study,
      }
      const res = this.links_getLink({ pathName, customQuery })
      return res
    },
    async fetchGmfAndReturnStatus(gametype) {
      const mode = getGameformatGroup(gametype)
      if (!this.$store.getters.gameformats_groupsSet[mode]) {
        this.loadingGmf = true
        const result = await this.$store.dispatch('get_gameformat_groups', [mode])
        this.loadingGmf = false
        if (!result || result.error) return 'error'
      }
      return 'continue'
    },
    async getAnalyzeItem() {
      if (!this.apiData) return null

      const ha = this.apiData
      const { custom_tree, game_mode } = ha

      if (
        !custom_tree &&
        (await this.fetchGmfAndReturnStatus(game_mode.gametype.name)) !== 'continue'
      ) {
        return null
      }

      const gmfItem = custom_tree
        ? null
        : {
            gametype: game_mode.gametype.name,
            depth: game_mode.depth,
            stacks: (game_mode.stacks || []).map(i => Number(i)).join('-'),
          }

      const { gameformats } = this.$store.getters
      const gameformat = custom_tree
        ? null
        : getGameformat({
            item: gmfItem,
            gameformats,
          })

      const { board } = ha
      const boards = [ha.board]
      const { setup_shortcut } = ha

      const { hero_position } = ha

      const gamePoints = ha.game_points
      let hSpots = gamePoints.map(gp => {
        const available_actions = gp.situation.available_actions.map(aa => {
          const rr = {
            ...aa.action,
            ...aa,
            correctness: aa.id ? aa.correctness || 'na' : null,
            is_selected: aa.selected,
          }
          return rr
        })
        const selected_action = available_actions.find(i => i.is_selected)
        const r = {
          game: gp.game,
          available_actions,
          selected_action,
          rng: gp.situation.rng,
          custom_solution_id: gp.custom_solution_id,
        }
        return r
      })
      hSpots = getHistorySpots({ history_spots: hSpots, hasSelectedAction: true, hasRng: true })
      hSpots = getHistorySpotsUrlParams({ history_spots: hSpots, board })
      hSpots = setHistoryEventType({ history_spots: hSpots })
      hSpots = hSpots.map(i => ({
        ...i,
        is_hero: i.type === 'player' ? i.position === ha.hero_position : false,
        is_bot: i.type === 'player' ? i.position !== ha.hero_position : false,
      }))

      const opponent = getLastSpotsOpponent({
        history_spots: hSpots,
        custom_tree,
        gameformat,
      })
      const hand_hero = ha.hand
      const { players } = hSpots[hSpots.length - 1]
      const hero = ha.hero_position

      const firstHeroMove = hSpots.findIndex(
        i => i?.is_hero && (i?.available_actions || []).some(a => a?.correctness),
      )
      hSpots[firstHeroMove === -1 ? hSpots.length - 1 : firstHeroMove].is_active = true
      let trainer_history_spots = hSpots

      hSpots = getCompleteHistorySpots({
        history_spots: hSpots,
        board,
        hasFirstBoardSpot: true,
        addMissingBoardSpots: true,
      })

      // spec spot play - next_street action selected
      const lastSpot = hSpots[hSpots.length - 1]
      if (lastSpot?.type === 'board') {
        hSpots.pop()
      }

      hSpots = getGroupFoldHistorySpots({
        history_spots: hSpots,
        hero_position,
        onlyRealFolds: false,
      })

      let correctness = null
      let stats_hand = null
      const trainerQuery = ha.session.settings
      if (trainerQuery.fh_trainer_mode === 'stop_after_action') {
        const heroSpots = hSpots.filter(
          i => i.type === 'player' && i.is_hero && i.selected_action_code,
        )
        const selected_action = heroSpots[heroSpots.length - 1].available_actions.find(
          i => i.is_preselected || i.is_selected,
        )
        const handCorrectness = getHandCorrectness({
          history_spots: hSpots,
          hero_position: hero,
        })
        correctness = {
          ...handCorrectness,
          total_ev_loss: selected_action?.ev_loss,
          correctness_group: selected_action?.correctness_group,
        }
        stats_hand = getHandStats({
          history_spots: hSpots,
          hero_position: hero,
        })
      } else {
        correctness = getHandCorrectness({
          history_spots: hSpots,
          hero_position: hero,
        })
        stats_hand = getHandStats({
          history_spots: hSpots,
          hero_position: hero,
        })
      }

      const allDrills = this.$store.getters.drills_all
      const { drill, fullQuery } = findDrill({ query: trainerQuery, drills: allDrills })
      const drill_name = drill ? drill.name || this.$t(`trainer_presets.${drill.id}`) : ''
      if (drill) {
        drill.name = drill_name
      }

      const item = drill
      const selected_drill = {
        category_id: item?.category_id || 'custom_drills',
        id: item?.id || '',
        name: item?.name || '',
        description: item?.description || '',
        favorite: item?.favorite || '',
      }

      const { custom_solution_id } = ha.game_points[ha.game_points.length - 1]
      const gameformatQuery = custom_tree
        ? {
            custom_solution_id,
            custom_tree_id: custom_tree.id,
          }
        : {
            stacks: gameformat.stacks,
            gametype: gameformat.gametype,
            depth: gameformat.depth,
          }

      const query = {
        ...fullQuery,
        ...ha.settings,
        ...gameformatQuery, // multiple gametypes - FE single chosen one can be different from BE chosen one
        board_tmp: ha.board,
        hand_tmp: hand_hero,
        hand_op_tmp: '',
        fh_hero_tmp: hero_position,
        fh_trainer_session: '',
      }

      const callParams = fullQuery
      const repeatParams = {
        ...gameformatQuery,
        board,
        hand: hand_hero,
        opponent_positions: callParams.fh_opponent?.split(',').filter(i => i),
        hero_positions: [hero_position],
        ...(setup_shortcut ? { shortcut_id: setup_shortcut.id } : {}),
        ...(setup_shortcut ? { label_id: setup_shortcut.label.id } : {}),
        ...(callParams.preflop_actions ? { preflop_actions: callParams.preflop_actions } : {}),
        ...(callParams.flop_actions ? { flop_actions: callParams.flop_actions } : {}),
        ...(callParams.turn_actions ? { turn_actions: callParams.turn_actions } : {}),
        ...(callParams.river_actions ? { river_actions: callParams.river_actions } : {}),
      }

      const trainerState = {
        trainer_custom_tree: custom_tree,
        trainer_practice_hand_id: ha.id,
        trainer_hand_finished: true,
        trainer_hand_settings: '',
        trainer_setup_repeat_params: repeatParams,
      }

      // ---------
      // 'stop_after_action' + 'stop_end_of_street' cleanup ------ TODO make BE do this -- not all situations are clean
      const sanitizeSpots = spots => {
        if (query.fh_trainer_mode === 'stop_after_action') {
          // dont show GG in stop_after_action mode
          spots = spots.filter(i => i.type !== 'showdown')
        }

        let l_lastSpot = spots[spots.length - 1]
        if (l_lastSpot?.type === 'player' && !l_lastSpot?.selected_action_code) {
          // cleanup last spot if it has no selected_action
          spots.pop()
        }

        l_lastSpot = spots[spots.length - 1]
        // cleanup board as hangin last spot
        if (l_lastSpot.type === 'board') {
          spots.pop()
        }
        return spots
      }
      hSpots = sanitizeSpots(hSpots)
      trainer_history_spots = sanitizeSpots(trainer_history_spots)
      // ---------

      const res = {
        id: ha.id,
        gameformat,

        custom_tree,
        custom_solution_id,

        history_spots: hSpots,
        boards,
        hand_hero,

        players,
        hero,
        opponent: opponent?.position ? opponent : {},

        date: ha.created_at,
        game_mode,

        historyHand: {
          query,
          drill,
          selected_drill,
          trainerState,
          history_spots: trainer_history_spots,
          street: trainer_history_spots[trainer_history_spots.length - 1].street,
          correctness,
          stats_hand,
        },
      }
      // console.log(res)
      return res
    },
  },
  computed: {
    haGmfItem() {
      const { apiData } = this
      const gameProperties = apiData?.game_mode?.gametype?.game_properties
      const res = {
        custom_tree: apiData?.custom_tree,
        variant: gameProperties?.variant || '',
        format: gameProperties?.format || '',
        date: apiData.created_at,
        players: this.analyzeItem.players,
      }
      return res
    },

    handsConfigure() {
      return this.$store.getters.hands_configure
    },
    panelReplay() {
      return this.$store.getters.panel_replay
    },
    replayedSpot() {
      return this.$store.getters[`${this.replayNamespace}/history_spot`]
    },

    lastSpotLink() {
      const hSpots = this.analyzeItem?.history_spots || []
      const lastSpot = hSpots[hSpots.length - 1]
      const res = this.getGameLink({ spot: lastSpot })
      return res
    },
    gmfQuery() {
      const gameformat = this.analyzeItem?.gameformat
      const custom_tree = this.analyzeItem?.custom_tree
      const custom_solution_id = this.analyzeItem?.custom_solution_id
      const res = custom_tree
        ? {
            custree_id: custom_tree.id,
            cussol_id: custom_solution_id,
            solution_type: 'custom',
          }
        : {
            gametype: gameformat?.gametype,
            depth: gameformat?.depth,
            stacks: gameformat?.stacks,
            solution_type: 'gwiz',
          }
      return res
    },

    loading() {
      const res = this.$store.getters.api_get('api_poker_practice_hand_detail')?.loading
      return res
    },
    loaded() {
      const res = this.$store.getters.api_get('api_poker_practice_hand_detail')?.loaded
      return res
    },
    apiData() {
      const res = this.$store.getters.api_get_data('api_poker_practice_hand_detail')
      // res = require('@/components/Trainer/practice_hand_mock.json')
      return res
    },
    warningZeroLine() {
      return (this.apiData?.game_points || []).some(i =>
        [
          'NON_ZERO_EV_FOLD', //
          'ZERO_RANGE',
          'EVS_FREQUENCIES_MISMATCH',
          'NEGATIVE_EV',
        ].includes(i.situation.warning),
      )
    },
    handDetailItem() {
      return this.$store.getters.globals_drawer?.item || {}
    },

    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    showEvIn() {
      return this.$store.getters.show_ev_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
  watch: {
    apiData() {
      this.handleLoaded()
    },
  },
}
</script>
<style lang="scss" scoped>
.trahhitem {
  &_replay {
    z-index: 1;
    --p-replay-left: var(--maximized-content-left);
  }
}
@media screen and (max-width: 1023px) {
  .trahhitem {
    &_replay {
      z-index: 4;
      --p-replay-left: 0;
    }
  }
}
</style>
